import { Option } from 'components/_inputs/_types/Option';

const createOptionsFromEnum = (sourceEnum: Record<string, string>): Option[] =>
  Object.entries(sourceEnum).map(([value, label]) => ({ value, label }));

export default createOptionsFromEnum;
